/* **************************************************** */
/* Pagination                                           */
/* **************************************************** */

export const handleBackPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
    if (pagination.currentPage > 1) {
        dispatch(setFilters({
            ...filters,
            page: pagination.currentPage - 1
        }));
        setRefetch(prevRefetch => !prevRefetch);
    }
}

export const handleNextPagination = (pagination, filters, dispatch, setFilters, setRefetch) => {
    if (pagination.currentPage < pagination.lastPage) {
        dispatch(setFilters({
            ...filters,
            page: pagination.currentPage + 1
        }));
        setRefetch(prevRefetch => !prevRefetch);
    }
}

export const handleClickPagination = (page, filters, dispatch, setFilters, setRefetch) => {
    dispatch(setFilters({
        ...filters,
        page: page
    }));
    setRefetch(prevRefetch => !prevRefetch);
}